export const AUDIT_FIELD_KEYS = {
  LEAD_ID: 'leadId',
  EVENT_DETAILS: 'eventDetails',
  EVENT_STATUS: 'eventStatus',
  EVENT_TYPE: 'eventType',
  OLD_DEDUPE_STATUS: 'oldDeDupeStatus',
  NEW_DEDUPE_STATUS: 'newDeDupeStatus',
  PROCESS_TYPE: 'processType',
  PROCESS_STATUS: 'processStatus',
  TIMESTAMP: 'timeStamp',
  USER: 'user',
} as const;

export type AuditFieldKey = (typeof AUDIT_FIELD_KEYS)[keyof typeof AUDIT_FIELD_KEYS];

export const isStatusField = (fieldKey: string): boolean => {
  return (
    fieldKey === AUDIT_FIELD_KEYS.EVENT_STATUS ||
    fieldKey === AUDIT_FIELD_KEYS.PROCESS_STATUS ||
    fieldKey === AUDIT_FIELD_KEYS.NEW_DEDUPE_STATUS ||
    fieldKey === AUDIT_FIELD_KEYS.OLD_DEDUPE_STATUS
  );
};

export const isTimestampField = (fieldKey: string): boolean => {
  return fieldKey.toLowerCase() === AUDIT_FIELD_KEYS.TIMESTAMP.toLowerCase();
};

export const isUserField = (fieldKey: string): boolean => {
  return fieldKey === AUDIT_FIELD_KEYS.USER;
};

export const isEventDetailsField = (fieldKey: string): boolean => {
  return fieldKey === AUDIT_FIELD_KEYS.EVENT_DETAILS;
};
